import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
const DATES: {
  date: string;
  city: string;
  venue: string;
  status: string;
}[] = [];
export function Tour() {
  return <section id="tour" className="py-24 md:py-32 px-6 md:px-12 max-w-screen-2xl mx-auto" data-id="element-86">
      <SectionHeader number="01" title="Live Dates" data-id="element-87" />

      <div className="flex flex-col" data-id="element-88">
        {DATES.length === 0 ? <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="py-16 md:py-24 border-y border-brand-white/10 text-center" data-id="element-89">
            <h3 className="font-display text-4xl md:text-6xl text-brand-white uppercase tracking-widest mb-4" data-id="element-90">
              No Dates Announced
            </h3>
            <p className="text-brand-muted uppercase tracking-widest text-sm" data-id="element-91">
              New shows coming soon — sign up below to be the first to know.
            </p>
          </motion.div> : DATES.map((show, i) => <motion.div key={i} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1,
        duration: 0.5
      }} className="group flex flex-col md:flex-row md:items-center justify-between py-6 md:py-8 border-b border-brand-white/10 hover:bg-brand-white/5 transition-colors px-4 -mx-4" data-id="element-92">
              <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-12 mb-4 md:mb-0" data-id="element-93">
                <span className="font-display text-2xl md:text-3xl text-brand-accent w-32" data-id="element-94">
                  {show.date}
                </span>
                <div data-id="element-95">
                  <h4 className="text-xl md:text-2xl font-bold text-brand-white uppercase tracking-wider" data-id="element-96">
                    {show.city}
                  </h4>
                  <p className="text-brand-muted uppercase tracking-widest text-sm mt-1" data-id="element-97">
                    {show.venue}
                  </p>
                </div>
              </div>

              <button disabled={show.status === 'SOLD OUT'} className={`px-8 py-3 font-display tracking-widest uppercase text-sm transition-all ${show.status === 'SOLD OUT' ? 'bg-transparent border border-brand-white/20 text-brand-white/50 cursor-not-allowed' : 'bg-brand-white text-brand-black hover:bg-brand-accent hover:text-brand-white'}`} data-id="element-98">
                {show.status}
              </button>
            </motion.div>)}
      </div>
    </section>;
}